import React from 'react';

const Droplet = () => {
  return (
    <svg width='28' height='32' viewBox='0 0 28 32' xmlns='http://www.w3.org/2000/svg'>
    <g id='Welcome' fill='none' fillRule='evenodd'>
        <g id='Mobile-Portrait' transform='translate(-246 -411)' fill='#282C37'
        fillRule='nonzero'>
            <g id='Toolbar' transform='translate(11 390)'>
                <g id='Icons' transform='translate(27 20)'>
                    <g id='Custom' transform='translate(199 1)'>
                        <g id='pour-rain-svgrepo-com' transform='translate(9)'>
                            <path d='M28,19.071758 C28,15.3934135 22.2654443,7.01482221 21.6115555,6.07141131 C21.3754337,5.73072115 20.9863387,5.52734913 20.5705956,5.52734913 C20.1550212,5.52734913 19.7659262,5.73072115 19.5298044,6.07157939 C19.3090305,6.39025159 18.5084088,7.55787594 17.5450318,9.10568832 C14.9527515,4.57553443 12.1968726,0.589442723 12.1655021,0.544062188 C11.9292116,0.203372026 11.5401166,0 11.1245422,0 C10.7089678,0 10.3198728,0.203372026 10.083751,0.544230264 C9.0515613,2.03355218 0,15.2587846 0,20.9145438 C0,27.0271338 4.99043466,32 11.1245422,32 C15.0864977,32 18.7801176,29.8535007 20.7551079,26.4679447 C24.766649,26.3699564 28,23.0911287 28,19.071758 Z M11.1247109,29.4790273 C6.38557729,29.4790273 2.5300453,25.6371448 2.5300453,20.9147119 C2.5300453,17.2496455 8.01701041,8.20732181 11.1218437,3.52052104 C12.2999229,5.30347182 14.2872253,8.40514733 16.0542598,11.6125427 C14.5533684,14.2683124 13.1435524,17.2477966 13.1435524,19.071758 C13.1435524,22.260833 15.1780792,24.9851778 18.0216606,26.0237197 C16.4153576,28.161311 13.8525925,29.4790273 11.1247109,29.4790273 Z M20.5707643,23.9516781 C17.8703739,23.9516781 15.6734291,21.7624875 15.6734291,19.071758 C15.6734291,17.7545459 17.0006024,15.0207889 18.5576571,12.331572 C18.5859917,12.2892169 18.6109532,12.2450129 18.6338907,12.1998004 C19.2692271,11.1081464 19.9393071,10.0277536 20.5711016,9.05661012 C22.7842377,12.4564525 25.4701234,17.1963654 25.4701234,19.071758 C25.4701234,21.7624875 23.2723352,23.9516781 20.5707643,23.9516781 Z'
                            id='Shape' />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
  );
}

export default Droplet;



// WEBPACK FOOTER //
// ./src/icons/Droplet.js